import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SenderVarService {
  id: string;
  isEdit = false;
  editId: string;

  constructor() {}

  /**
   * Resolves project/site id from the route tree (e.g. `page/:id`, `rum/:id`) or URL.
   * Leaf routes often omit `:id`; use this before API calls that read `this.id`.
   */
  resolveProjectIdFrom(route: ActivatedRoute, router: Router): string | null {
    for (const r of route.pathFromRoot) {
      const id = r.snapshot.paramMap.get('id');
      if (id) {
        return id;
      }
    }
    const path = router.url.split('?')[0];
    const patterns = [
      /\/home\/page\/([^/]+)/,
      /\/home\/rum\/([^/]+)/,
      /\/internal-detail-po\/([^/]+)/,
      /\/diff-alert\/([^/]+)/,
    ];
    for (const re of patterns) {
      const m = path.match(re);
      if (m?.[1]) {
        return decodeURIComponent(m[1]);
      }
    }
    return null;
  }

  syncProjectIdFromRoute(route: ActivatedRoute, router: Router): string | null {
    const id = this.resolveProjectIdFrom(route, router);
    if (id) {
      this.id = id;
    }
    return id;
  }
}
